/**
 * Shared logout / 401 cleanup — auth, cart, outlet content, React Query.
 */
export default function clearSession(dispatch, queryClient) {
	dispatch({ type: 'auth/setLogout' });
	dispatch({ type: 'cart/resetItems' });
	dispatch({ type: 'content/resetOutlet', payload: false });
	dispatch({ type: 'content/resetFetchAPI', payload: false });
	if (queryClient) {
		queryClient.clear();
	}
}
